import styled from 'styled-components';
import {useLoggedIn} from "../store";
import {themecolors} from "../utils/themecolors";
import {useHistory} from "react-router-dom";
import {useSheetModal} from "./test/ModalContext";
import Sheet from "./bottom-sheet/sheet";
import SignupPromptSheet from "./bottom-sheet/signup_prompt";
import React from "react";

const CommunityTopics = ['Home', 'Trending', 'All'];

const Container = styled.div``;
const Inner = styled.div``;
const FeedBarActive = styled.div``;

const Items = styled.div``;
const Item = styled.div``;

const TrendingToggles = styled(({className}) => {

    const loggedIn = useLoggedIn();
    const currentTab = location.pathname.startsWith("/c/trending") ? 'Trending' : (location.pathname.startsWith("/c/all") ? 'All' : (loggedIn ? 'Home' : 'Trending'));

    const history = useHistory();
    const { openModal } = useSheetModal();

    const handleTopic = async (topic) => {

        if (topic === "Home") {
            if (loggedIn) {
                history.push('/');
            } else {

                const modalContent = ({ handleCloseModal }) => (
                    <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
                );

                openModal(modalContent);

            }
        } else if (topic === "Trending") {
            history.push('/c/trending');
        } else {
            history.push('/c/all');
        }

    };

    return (
        <Container className={className}>
            <Inner>
                    <Items>
                        {CommunityTopics?.map((topic) => {
                            return (
                                    <Item className={topic === currentTab ? 'active-feed' : ''} onClick={() => handleTopic(topic)} key={topic}>
                                        {topic}
                                    </Item>
                            );
                        })}
                    </Items>
            </Inner>
        </Container>
    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : '#fff'};
  width: 100%;
  display: flex;
  flex-direction: row;
  font-weight: 600;
  
  ${Inner} {
    margin: 0 auto;
    font-size: 18px;
    padding: 12px 0 8px 0;
    display: flex;
    align-items: center;
    flex-grow: 1;
    max-width: 100%;
  }
  
  ${FeedBarActive} {
    margin-right: 24px;
    max-width: 332px;
    white-space: nowrap;
  }
  
  ${Item}:first-of-type {
    margin-left: 0;
  }
  
  ${Item} {
    border-radius: 48px;
    padding: 6px 16px;
    font-size: 16px;
    cursor: pointer;
    white-space: nowrap;
    margin-right: 4px;
    margin-left: 4px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : '#eaeaea'};
    display: flex;
    align-items: center;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }

  ${Items} {
    width: 100%;
    flex-grow: 1;
    padding: 0px 16px;
    display: flex;
    overflow: scroll;
    flex-shrink: 0;
    align-items: center;
    overflow: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  ${Items}::-webkit-scrollbar {
    display: none;
  }
  .active-feed {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'white' : 'black'};
    color: ${({theme}) => theme.color.name === 'dark' ? 'black' : '#fff'};
  }
  
`;

export default TrendingToggles;
